import React from 'react';
import styles from './styles.module.scss';
import { useEffect, useState } from 'react';
import { infoInvitation } from 'services/rsvp/getRSVP';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import { useHistory } from 'react-router-dom';

const InvitationFromImage = ({ data, imgInvitation, typeIdFather, idReturn=0, etapa=0, configurationDesktopInv={} }) => {
  console.log('data invitation imagen', imgInvitation);
  console.log('data vacio', data);
  console.log('etapa en componente ', etapa);

  const [dataInvitation, setDataInvitation] = useState([]);
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  const history = useHistory();

  useEffect(() => {
    if (etapa === 6) {
      console.log('data invitation -------', data);
      const tmpDataInvitacion = {
        event_name : data?.event_name,
        event_date : data?.event_date,
        event_hour : data?.time,
        name : data?.celebrate_name,
        address : data?.address,
        message : data?.message,
        template_url : imgInvitation,
      };
      setDataInvitation(tmpDataInvitacion);
      console.log('data invitation tmpDataInvitacion', tmpDataInvitacion);
    }
  },[data]);

  useEffect(() => {
    dispatch(showLoader());
    infoInvitation(typeIdFather).then((valorDeServicio) => {
      console.log('infoInvitation serivico recupera invitacion', valorDeServicio);
      if(valorDeServicio?.metadata?.http_status !== 404){
        setDataInvitation(valorDeServicio?.data);
        dispatch(hideLoader());
      }
      if(idReturn === 1 && valorDeServicio?.data.length === 0){
        alert ('No hay invitacion para mostrar');
        dispatch(hideLoader());
        history.push('/');
      }
      if(valorDeServicio?.metadata?.http_status === 404){
        dispatch(hideLoader());
      }
    });
   // dispatch(hideLoader());
  }, []);

  useEffect(() => {
    if(dataInvitation?.gift_table > 0){
      dispatch(hideLoader());
    }
    console.log('imgInvitation controlado ', imgInvitation);
  }, [dataInvitation]);

  console.log('dataInvitation', dataInvitation);
  console.log('configurationDesktopInv',configurationDesktopInv);

  return (
    <div className='shadow border rounded'>
      <img src={dataInvitation.template_url } width="100%" height="740px" />
      <p style={configurationDesktopInv?.titulo}>{dataInvitation?.event_name}</p>
      <p style={configurationDesktopInv?.fecha}>{dataInvitation?.event_date}</p>
      <p style={configurationDesktopInv?.nombre}>{dataInvitation?.name}</p>
      <p style={configurationDesktopInv?.punto}>·</p>
      <p>LUGAR Y HORA :</p>
      <p style={configurationDesktopInv?.direccion}>{dataInvitation?.address}</p>
      <p style={configurationDesktopInv?.hora}>{dataInvitation?.event_hour}</p>
      <p style={configurationDesktopInv?.punto}>·</p>
      <p style={configurationDesktopInv?.mensaje}>{dataInvitation?.message}</p>
    </div>
  );
};

export default InvitationFromImage;
